// extracted by mini-css-extract-plugin
export default {"user":"SummaryStep_user__7pSZ0","customer":"SummaryStep_customer__WiRBH"};